import React, { Fragment, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import { receive, receiveList, changeMode, receiveOrderArticles } from '../../ActionsBrafab/Returns.action'
import { ViewMode } from '../../constants';

const PendingReturnButtons = ({ showDetails, deletePendingRow, returnSchema, setError }) => {
    const { pendingReturn, orderArticles, list, currentPage } = useSelector((state) => state.myPage.returns);

    const [isValid, setIsValid] = useState(true);
    const [returnCreated, setReturnCreated] = useState(null);
    const dialogRef = useRef(null);


    useEffect(() => {
        if (pendingReturn?.returnRows?.length > 0) {
            const isPendingReturnValid = pendingReturn.returnRows.every((returnObject) => {
                returnSchema.validate(returnObject).catch(() => {
                    return false;
                });
            });

            setIsValid(isPendingReturnValid);
        }
    }, [pendingReturn]);

    const onToggle = (button) => {
        button.classList.toggle("active");
    };

    const onClick = (returnId, rowSystemId, articleNumber, orderNumber) => {
        const goOn = confirm(translate("code.mypage.returndetails.confirm.deleterow"));
        if (goOn) {
            var articleIndex = orderArticles?.findIndex(i => i.articleNumber === articleNumber);
            if (articleIndex >= 0) {
                var orderIndex = orderArticles[articleIndex].orders.findIndex(x => x.orderNumber == orderNumber);
                if (orderIndex >= 0) {
                    deletePendingRow(returnId, rowSystemId, articleIndex, orderIndex);
                    return;
                }
            }

            deletePendingRow(returnId, rowSystemId);
        }
    };

    const onSubmit = () => {
        const goOn = confirm(translate("code.mypage.returndetails.confirm.send"));
        if (goOn) {
            // Validate each return row
            const validationPromises = pendingReturn?.returnRows.map((returnObject) => {
                return returnSchema.validate(returnObject)
                    .catch(() => {
                        return false;
                    });
            });

            Promise.all(validationPromises)
                .then(() => {
                    submit(pendingReturn.id)
                        .then((response) => response.json())
                        .then((result) => {
                            setReturnCreated(result);
                            dialogRef.current.showModal();
                        })
                        .catch(() => {
                            setReturnCreated(null);
                            dialogRef.current.showModal();
                        });
                })
                .catch((error) => {
                    setReturnCreated(null);
                    dialogRef.current.showModal();
                    dispatch(setError(error))
                });
        }
    }

    const onDialogClick = () => {
        dialogRef.current.close();
        if (returnCreated) {
            dispatch(receive({}));
            dispatch(receiveOrderArticles([]));

            //If return list is on page one, we must add it first in list
            if (currentPage == 1) {
                list.unshift(returnCreated);
                if (list.length > 15) {
                    list.pop();
                }
                dispatch(receiveList(list))
            }
            dispatch(changeMode(ViewMode.List));
        }
    }

    return (
        <Fragment>
            {pendingReturn && pendingReturn.returnRows && pendingReturn.returnRows.length > 0 &&
                <div className="returns__pending-panel">
                    <div className="pending-info">
                        <button className="returns__pending-panel-toggle-info button" onClick={(event) => onToggle(event.target)}>
                            {translate('code.mypage.return.showpendinglist')} <i className="fas fa-info-circle"></i> <i className="fas fa-chevron-down"></i>
                        </button>
                        <ul>
                            {pendingReturn.returnRows.map((row, rowIndex) => (
                                <li key={rowIndex}>
                                    <div className="row">
                                        <div className="small-8 columns"><b>{row.articleNumber} {row.articleName}</b>
                                            <span className="returns__pending-panel-toggle-info-order-date-formatted">{row.orderDate}</span>
                                        </div>
                                        <div className="small-2 columns">{row.returnedQuantity}</div>
                                        <div className="small-2 columns text-right">
                                            <button onClick={() => onClick(pendingReturn.id, row.systemId, row.articleNumber, row.orderNumber)}>
                                                {translate('code.mypage.return.deletependingrow')} <i className="fas fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                        <button onClick={() => showDetails()} className="returns__pending-panel-pending-goto button">
                            {translate('code.mypage.return.showpendingdetails')} <i className="fas fa-cog"></i>
                        </button>
                        <button onClick={() => onSubmit()}
                            className="returns__pending-panel-pending-send button"
                            disabled={!isValid}
                        >
                            {translate('code.mypage.returndetails.button.send')} <i className="fa fa-paper-plane"></i>
                        </button>
                    </div>
                </div>
            }
            <dialog ref={dialogRef} className='returns__dialog'>
                <button className="checkout-reseller__termsdialog--close" value="cancel" onClick={() => dialogRef.current.close()}>
                    X
                </button>
                <h4>
                    {returnCreated ? (
                        translate('code.mypage.returndetails.created.title')
                    ) : (
                        translate('code.mypage.returndetails.notcreated.title')
                    )}
                </h4>
                {returnCreated ? (
                    <span>{translate('code.mypage.returndetails.created.message')} {returnCreated.id}.</span>
                ) : (
                        <span>{translate('code.mypage.returndetails.notcreated.message')} <a href={`mailto:${translate('code.mypage.returndetails.notcreated.message.mail')}`}>{translate('code.mypage.returndetails.notcreated.message.mail')}</a>.</span>
                )}
                <button onClick={() => onDialogClick()} className='button returns__dialog--button'>{translate('code.mypage.returndetails.message.ok') }</button>
            </dialog>     
        </Fragment>
    );
}
export default PendingReturnButtons;